export default __webpack_public_path__ + "static/media/established-marketing.81e9b8ce.png";